export const ASSET_PATH = 'https://d14knz87alb4l4.cloudfront.net';
export const FCD_PATH = 'https://fcd.terra.dev';
